export default "/public/dist/img/imagenews.png";